export enum GameRoundViewType {
  Games,
  Ranking,
}
